const translations = {
  "en": {
    "Don't Miss the Gains": "Don't Miss the Gains",
    "Instant alerts for Edgen's Picks & earnings signals. Never miss a trade.": "Instant alerts for Ed's Picks & earnings signals. Never miss a trade.",
    "Let Ed keep an eye out": "Let Ed keep an eye out",
    "Maybe Later": "Maybe Later",
    "Turn on alerts and Ed will flag the moves worth a look on the things you're tracking.": "Turn on alerts and Ed will flag the moves worth a look on the things you're tracking.",
    "Yes, Notify me": "Yes, Notify me"
  },
  "zh-tw": {
    "Don't Miss the Gains": "別錯過獲利機會",
    "Instant alerts for Edgen's Picks & earnings signals. Never miss a trade.": "即時警報，掌握 Ed 的選股與財報訊號。不錯過任何交易機會。",
    "Let Ed keep an eye out": "讓 Ed 為你留意",
    "Maybe Later": "暫不",
    "Turn on alerts and Ed will flag the moves worth a look on the things you're tracking.": "開啟通知，Ed 將標記你追蹤標的中值得關注的動向。",
    "Yes, Notify me": "好，通知我"
  }
};

export default translations;
